module.exports = __webpack_public_path__ + "static/media/T5LSLFW.d6457b8e.png";